export default "__VITE_ASSET__D$Hxorx6__"